<script>
export default {
  name: "pageUrl"
}
</script>

<template>
  <div></div>
</template>

<style scoped>

</style>